import { Modal } from 'ui';
import ContactUsForm from './ContactUsForm';

type P = {
  isOpened: boolean;
  onClose: () => void;
  onSuccess: (programId: string) => void;
  programId: string;
  userPhone?: string;
};

const ContactUsModal = ({ isOpened, onClose, onSuccess, programId, userPhone }: P) => (
  <Modal isOpened={isOpened} onCancel={onClose} title="Contact me at" width="medium">
    <Modal.HugContent>
      <ContactUsForm onSuccess={onSuccess} programId={programId} userPhone={userPhone} />
    </Modal.HugContent>
  </Modal>
);

export default ContactUsModal;
